import { ImageWraper } from '@components/shared/wraper/ImageWraper'
import { cloudfrontPath } from '@utils/image'
import React from 'react'

type Props = {
  iconPath: string
  heading: string
  Htag: keyof JSX.IntrinsicElements
}

export const HeadingWithIcon = ({
  iconPath,
  heading,
  Htag,
}: Props): JSX.Element => (
  <div className="flex justify-center md:justify-start w-full">
    <div className="mt-[9px] md:mt-[6px] mr-[2vw] md:mr-[.5vw] md:ml-[5.5vw] w-[16px] md:w-[24px]">
      <ImageWraper
        src={`${cloudfrontPath}${iconPath}`}
        width={24}
        height={30}
      />
    </div>
    <div className="w-auto">
      <Htag className="w-full">{heading}</Htag>
    </div>
  </div>
)
